import { render, staticRenderFns } from "./EditOrderRoute.vue?vue&type=template&id=2f77d3dc"
import script from "./EditOrderRoute.vue?vue&type=script&lang=ts"
export * from "./EditOrderRoute.vue?vue&type=script&lang=ts"
import style0 from "./EditOrderRoute.vue?vue&type=style&index=0&id=2f77d3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports